import { Alert, Stack, Typography } from '@mui/joy';
import { WarningCircle } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';

import { Button } from 'core/components';
import { Color, Level, Size, Variant } from 'theme/enums';

const ICON_SIZE = 24;

interface IProps {
  onRetry: () => void;
}

/**
 * Mirrors VendorQuoteLog's ReportError. A failed load must not fall through to an
 * empty list: "there is nothing to clear" is a claim, and an admin who came here to
 * clear a cache would read it as the feature being unavailable rather than broken.
 */
export const CacheLoadError = ({ onRetry }: IProps) => {
  const { t } = useTranslation();

  return (
    <Alert
      color={Color.DANGER}
      endDecorator={
        <Button
          color={Color.DANGER}
          onClick={onRetry}
          size={Size.SM}
          text={t('buttonLabelRetry')}
          variant={Variant.OUTLINED}
        />
      }
      size={Size.LG}
      startDecorator={<WarningCircle size={ICON_SIZE} />}
      sx={{ alignItems: 'center', width: '100%' }}
      variant={Variant.SOFT}
    >
      <Stack>
        <Typography level={Level.TITLE_SM}>{t('errorTitleCacheLoad')}</Typography>

        <Typography level={Level.BODY_SM}>{t('messageCacheLoadError')}</Typography>
      </Stack>
    </Alert>
  );
};
